export { activateDevice } from "./activateDevice";
export type { DefaultPayload } from "./types";
export { verifyCustomer } from "./verifyCustomer";
